<template>
  <path
    d="M4.51004 15.4802L6.51004 13.8902C6.99004 13.5102 7.27003 12.9302 7.27003 12.3202V9.72023C10.29 8.74023 13.56 8.73023 16.59 9.72023V12.3302C16.59 12.9402 16.87 13.5202 17.35 13.9002L19.34 15.4802C20.14 16.1102 21.28 16.0502 22 15.3302L23.22 14.1102C24.02 13.3102 24.02 11.9802 23.17 11.2302C16.76 5.57023 7.10003 5.57023 0.690035 11.2302C-0.159965 11.9802 -0.159965 13.3102 0.640035 14.1102L1.86003 15.3302C2.57003 16.0502 3.71004 16.1102 4.51004 15.4802Z"
  />
</template>
